export class Confirmation {
    callback;
    title;
    cancelCallback;
    confirmButtonLabel = 'Yes';
    cancelButtonLabel = 'No';

    constructor(callback, title = 'Are you sure?', cancelCallback = null, buttonLabels) {
        this.callback = callback;
        this.title = title;
        this.cancelCallback = cancelCallback;
        if (buttonLabels) {
            this.confirmButtonLabel = buttonLabels.confirmButtonLabel;
            this.cancelButtonLabel = buttonLabels.cancelButtonLabel;
        }

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/confirm/Confirmation.js